module.exports = __webpack_public_path__ + "static/media/holidays.55fd0a99.svg";